import React from "react";
import { withTranslation } from "react-i18next";

import {
  ButtonGroup,
  Col,
  Container,
  Row,
  ToggleButton,
} from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faFilter,
  faPlus,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { textFilter } from "react-bootstrap-table2-filter";
import IsolationHardwareActionCell from "./isolationHardwareActionCell/IsolationHardwareActionCell";
import CreateIsolationHardware from "./dialogs/createIsolationHardware/CreateIsolationHardware";
import StorageService from "../../../../services/StorageService";
import UnsavedChangesDialog from "../../../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";

class IsolationHardwareTab extends React.Component {
  constructor(props) {
    super(props);
    this.tableId = "isolationHardwareTable";
    let showFilters = StorageService.getTableConfigValue(
      this.tableId,
      "showFilters"
    );
    this.state = {
      isolationHardware: [],
      showCreateModal: false,
      showUnsavedChangesDialog: false,
      dialogApiError: "",
      apiError: "",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
    };

    this.handleCreate = this.handleCreate.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.loadData = this.loadData.bind(this);

    this.paginationTableRef = React.createRef();
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    try {
      const isolationHardware = await CamplaCoreService.getAllIsolationHardware();
      this.setState({ isolationHardware });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleCreate(isolationHardware) {
    try {
      const singleIsolationHardware = await CamplaCoreService.createIsolationHardware(
        isolationHardware
      );
      this.setState({
        isolationHardware: [
          ...this.state.isolationHardware,
          singleIsolationHardware,
        ],
        showCreateModal: false,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleRemove(singleIsolationHardware) {
    try {
      await CamplaCoreService.deleteIsolationHardware(
        singleIsolationHardware._id
      );
      const isolationHardware = this.state.isolationHardware.filter(
        (i) => i._id !== singleIsolationHardware._id
      );
      this.setState({ isolationHardware });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;

    const columns = [
      {
        dataField: "currentInstance",
        text: "",
        sort: false,
        headerStyle: () => ({ width: "40px" }),
        isDummyField: true,
        csvExport: false,
        formatter: (currentInstance) => {
          return (
            <span>
              {currentInstance !== null ? (
                <FontAwesomeIcon icon={faUser} className="color-red" />
              ) : (
                <FontAwesomeIcon icon={faCircle} className="color-green" />
              )}
            </span>
          );
        },
      },
      {
        dataField: "identifier",
        text: t("Hardware.Tabs.IsolationHardware.ColumnIdentifier"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "product",
        text: t("Hardware.Tabs.IsolationHardware.ColumnProduct"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "serialNumber",
        text: t("Hardware.Tabs.IsolationHardware.ColumnSerialNumber"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
        formatter: (serialNumber) => {
          return <span style={{ fontSize: "8pt" }}>{serialNumber}</span>;
        },
      },
      {
        dataField: "osVersion",
        text: t("Hardware.Tabs.IsolationHardware.ColumnOsVersion"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup toggle style={{ float: "right", marginRight: "-12px" }}>
            <ToggleButton
              type="checkbox"
              value={1}
              className="btn-green btn-sm"
              checked={this.state.showFilters}
              onChange={(e) => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none",
                });
                StorageService.setTableConfigValue(
                  this.tableId,
                  "showFilters",
                  e.currentTarget.checked
                );
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, isolationHardware) => {
          return (
            <IsolationHardwareActionCell
              onDelete={() => this.handleRemove(isolationHardware)}
            />
          );
        },
      },
    ];

    return (
      <div>
        <CreateIsolationHardware
          show={this.state.showCreateModal}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () => this.setState({ showCreateModal: false }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateModal: false,
              });
            }
          }}
          onSubmit={this.handleCreate}
          dialogApiError={this.state.dialogApiError}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <Container className="mt-3 pl-0 pr-0">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Hardware.Tabs.IsolationHardware.Title")}</h2>
            </Col>
            <Col>
              <Button
                className="btn-green floatRight"
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <PaginationTable
                data={this.state.isolationHardware}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField={"_id"}
                ref={this.paginationTableRef}
                id={this.tableId}
                view="isolationHardwareTab"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(IsolationHardwareTab);
